import React from "react"

export const SiteLaunchFailureImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="400"
      height="400"
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="159.883" cy="82.4862" r="19.0316" fill="#E2B73E" />
      <path d="M37.8366 136.132V357.502" stroke="#1D2B47" />
      <path d="M67.2273 117.221V357.502" stroke="#1D2B47" />
      <path d="M96.6101 101.122V357.502" stroke="#1D2B47" />
      <path d="M126.001 96.5239V357.502" stroke="#1D2B47" />
      <path d="M155.384 101.122V357.502" stroke="#1D2B47" />
      <path d="M184.774 87.0688V357.502" stroke="#1D2B47" />
      <path d="M214.165 62.0239V357.502" stroke="#1D2B47" />
      <path
        d="M14.6044 136.719L13.7969 135.289L110.158 80.832C113.916 78.7364 118.603 79.353 121.691 82.349L134.799 94.991C137.539 97.6572 141.77 98.0445 144.948 95.9201L216.245 48.688L217.155 50.0561L145.854 97.2686C142.036 99.823 136.951 99.3588 133.659 96.1553L120.55 83.5133C117.983 81.019 114.084 80.5043 110.958 82.2471L14.6044 136.719Z"
        fill="#1D2B47"
      />
      <path
        d="M222.358 56.9592L230.198 40.9303C230.505 40.3037 230.44 39.5588 230.029 38.995C229.618 38.4313 228.929 38.1411 228.238 38.2412L210.649 40.7304C209.997 40.8214 209.44 41.2476 209.182 41.8534C208.923 42.4593 209.001 43.1562 209.387 43.69L219.144 57.2336C219.531 57.7689 220.171 58.0621 220.829 58.0059C221.487 57.9497 222.068 57.5524 222.358 56.9592Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M231.281 134.285L194.461 109.256L202.74 94.0815L250.493 121.792L304.719 117.453L294.66 142.889L273.265 144.987C258.449 146.439 243.594 142.653 231.281 134.285Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M198.562 131.318L203.913 119.761L213.713 122.337L223.168 105.92L250.499 121.78L304.724 117.441L293.681 145.347L249.115 151.549C241.483 152.611 233.713 151.136 227.002 147.35L198.562 131.318Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M195.508 119.715C193.155 123.8 194.559 129.019 198.644 131.373C202.729 133.725 207.948 132.321 210.302 128.237L213.712 122.325L199.561 112.706L195.508 119.715Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M261.316 307.961L331.849 303.488C337.315 303.143 342.487 300.893 346.467 297.13L370.128 274.77C373.05 272.016 377.504 271.689 380.798 273.986L382.143 274.919C384.278 276.411 385.611 278.8 385.757 281.401C385.903 284.002 384.846 286.526 382.891 288.247L353.679 313.845C349.818 317.226 344.954 319.248 339.834 319.599L262.422 324.891C259.762 325.073 257.171 323.994 255.427 321.978C253.683 319.962 252.988 317.243 253.551 314.637C254.353 310.924 257.525 308.196 261.316 307.961Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M315.699 160.882L300.486 262.767L298.847 357.435L283.363 346.091L243.242 357.004L271.141 339.991C271.141 339.991 267.393 229.917 282.399 179.271C303.951 162.615 315.699 160.882 315.699 160.882Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M303.447 262.175C325.179 298.153 341.541 314.111 341.541 314.111L356.794 335.773L339.056 357.415L374.54 327.521L383.807 324.405L328.343 247.679L319.672 179.181L291.612 177.323C291.612 177.323 284.353 230.576 303.447 262.175Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M261.315 307.961L331.848 303.488C337.314 303.142 342.486 300.893 346.465 297.13L370.126 274.77C373.049 272.016 377.503 271.689 380.797 273.986L382.141 274.919H382.165L345.234 246.448L329.99 179.592L323.588 133.866C322.29 124.595 314.36 117.699 305 117.699C295.311 117.702 287.215 125.077 286.313 134.724L285.956 138.542C281.104 138.606 277.081 142.319 276.631 147.151C276.181 151.982 279.447 156.375 284.204 157.335L279.445 184.339L253.906 313.452C255.08 310.323 257.98 308.174 261.315 307.961Z"
        fill="white"
      />
      <path
        d="M288.316 129.871L285.964 138.542C281.112 138.606 277.089 142.319 276.639 147.151C276.188 151.982 279.455 156.375 284.212 157.335L279.453 184.339L253.906 313.453C255.081 310.325 257.981 308.177 261.315 307.965L331.848 303.488C337.314 303.142 342.486 300.893 346.465 297.13L370.126 274.77C373.049 272.016 377.503 271.689 380.797 273.986L382.141 274.919H382.165L345.234 246.448L329.99 179.592L323.588 133.866C322.29 124.595 314.36 117.699 305 117.699"
        stroke="#1D2B47"
      />
      <path
        d="M298.834 116.504L294.13 118.966C292.903 119.609 291.955 120.682 291.469 121.98L290.469 124.646C290.326 125.03 290.403 125.462 290.671 125.772C290.938 126.083 291.354 126.224 291.755 126.139L299.446 124.505L298.834 116.504Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M293.891 121.337L296.356 128.632L300.692 122.239L301.002 117.699"
        fill="white"
      />
      <path
        d="M293.891 121.337L296.356 128.632L300.692 122.239L301.002 117.699"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M297.188 84.803H303.961C309.597 84.8046 314.426 88.8349 315.435 94.3795L315.878 96.8217C316.403 99.7127 318.922 101.814 321.86 101.812C325.644 101.807 328.914 104.453 329.7 108.154L330.335 111.145C330.706 112.898 330.267 114.724 329.139 116.116C328.012 117.508 326.317 118.318 324.526 118.319H302.138L297.188 84.803Z"
        fill="#1D2B47"
      />
      <path
        d="M299.567 84.803H289.014C287.438 84.7964 285.958 85.5552 285.043 86.8379C284.128 88.1207 283.893 89.7678 284.412 91.2553C284.909 92.6342 285.599 93.9355 286.462 95.1205C287.26 96.2239 287.691 97.5496 287.697 98.9111C287.699 101.538 289.828 103.668 292.456 103.67H295.745L299.567 84.803Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M308.118 100.369L309.769 119.146L297.805 123.478V100.577"
        fill="#EEC493"
      />
      <path
        d="M297.805 123.478V100.577"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M297.805 108.331C297.805 108.331 300.898 108.621 303.167 107.178C302.548 110.706 297.805 114.712 297.805 114.712V108.331Z"
        fill="#1D2B47"
      />
      <circle cx="299.97" cy="100.471" r="8.14968" fill="#EEC493" />
      <path
        d="M303.169 107.97C300.129 109.264 296.61 108.594 294.257 106.275C291.904 103.956 291.184 100.447 292.434 97.3886C293.683 94.3306 296.655 92.3294 299.959 92.3215"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M312.382 98.9541L308.737 106.97C308.737 106.97 304.425 106.97 304.197 101.4C306.883 100.369 305.644 96.4492 303.786 97.0686C301.928 97.6879 302.135 102.02 302.135 102.02C302.135 102.02 301.477 101.757 301.214 99.0246C301.07 97.6349 299.929 96.5607 298.533 96.5002C295.742 96.3473 292.555 94.1482 290.693 90.8436C289.669 89.0286 289.129 86.9808 289.125 84.897C294.574 84.7833 300.74 84.795 305.268 84.8264C308.209 84.8265 310.95 86.3134 312.554 88.7783C314.159 91.2432 314.408 94.352 313.217 97.0411L312.382 98.9541Z"
        fill="#1D2B47"
      />
      <path
        d="M308.737 106.97C308.737 106.97 304.425 106.97 304.197 101.4C306.883 100.369 305.644 96.4492 303.786 97.0686C301.928 97.6879 302.135 102.02 302.135 102.02C302.135 102.02 301.477 101.757 301.214 99.0247C301.07 97.6349 299.929 96.5607 298.533 96.5002C295.742 96.3473 292.555 94.1482 290.693 90.8436C289.669 89.0286 289.129 86.9808 289.125 84.897"
        stroke="#1D2B47"
      />
      <path
        d="M309.765 119.142L308.734 106.97"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M312.035 106.971H308.734"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M289.141 84.803H303.962C309.598 84.8046 314.427 88.8349 315.436 94.3795L315.879 96.8217C316.404 99.7127 318.923 101.814 321.861 101.812C325.645 101.807 328.915 104.453 329.701 108.154L330.336 111.145C330.707 112.898 330.268 114.724 329.14 116.116C328.013 117.508 326.318 118.318 324.526 118.319H309.76"
        stroke="#1D2B47"
      />
      <path
        d="M331.664 194.206L287.113 210.635L279.438 195.143L325.795 171.811L298.838 139.362L320.915 126.571L344.4 158.256C348.578 163.941 349.902 171.234 347.987 178.025C346.072 184.815 341.133 190.343 334.6 193.007L331.664 194.206Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M309.361 220.031L310.263 202.101L301.462 184.069L319.263 173.83L296.57 138.158L309.157 131.278L320.133 125.273L348.953 161.027C357.785 173.038 355.558 193.21 338.64 202.081L309.15 220.031"
        fill="white"
      />
      <path
        d="M319.462 124.509L348.952 161.027C357.784 173.038 355.557 193.21 338.639 202.081L309.148 220.031"
        stroke="#1D2B47"
      />
      <path
        d="M309.36 220.031L310.257 202.101L301.461 184.057L319.266 173.818L303.288 148.691"
        stroke="#1D2B47"
      />
      <path
        d="M298.029 215.966C300.099 220.199 305.207 221.953 309.44 219.886C313.673 217.817 315.428 212.709 313.36 208.475L310.248 202.089L294.164 208.036L298.029 215.966Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M345.258 246.44L348.786 264.594C348.786 264.594 354.819 256.824 358.3 256.479C353.07 252.697 345.258 246.44 345.258 246.44V246.44Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M303.223 118.331L308.534 116.594C309.743 116.201 311.069 116.567 311.905 117.523L312.576 118.288C313.455 119.292 313.399 120.809 312.446 121.745L306.849 127.253C306.304 127.795 305.541 128.059 304.778 127.969C304.015 127.88 303.334 127.447 302.929 126.794C302.565 126.216 301.974 125.819 301.301 125.701C300.629 125.584 299.938 125.757 299.401 126.178L296.562 128.429L297.66 124.23C298.392 121.447 300.487 119.225 303.223 118.331Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M296.564 128.428L294.914 138.127L296.564 128.428Z"
        fill="white"
      />
      <path
        d="M296.564 128.428L294.914 138.127"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M262.108 350.834H298.956L299.513 318.651H270.756C270.787 322.963 270.842 326.761 270.897 329.905C271.006 335.907 267.191 341.281 261.489 343.158L260.156 343.503C261.144 344.824 262.351 347.184 262.108 350.834Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M298.96 348.96H262.112C262.355 345.31 261.163 344.809 260.152 343.472L251.803 345.644C246.483 347.388 242.759 351.575 241.281 356.972H242.104L279.454 357.259C279.473 354.754 281.518 352.738 284.023 352.756C286.528 352.775 288.543 354.82 288.525 357.325L298.854 357.404L298.96 348.96Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <rect
        x="268.711"
        y="316.381"
        width="33.4219"
        height="6.18968"
        rx="3.09484"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M268.148 348.96C268.148 348.96 279.03 344.217 280.692 331.837C281.108 325.236 280.692 322.555 280.692 322.555"
        fill="white"
      />
      <path
        d="M268.148 348.96C268.148 348.96 279.03 344.217 280.692 331.837C281.108 325.236 280.692 322.555 280.692 322.555"
        stroke="#1D2B47"
      />
      <path
        d="M267.812 334.303C267.812 334.303 269.541 331.673 272.622 333.703"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M266.305 337.086C266.305 337.086 268.567 334.895 271.126 337.553"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M264.961 338.666C264.961 338.666 267.768 337.231 269.438 340.52"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M267.984 331.418C267.984 331.418 269.713 328.784 272.794 330.818"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M268.172 328.533C268.172 328.533 269.901 325.899 272.982 327.929"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M265.768 330.61C265.768 330.61 258.014 325.714 257.716 329.215C257.419 332.715 263.255 333.135 262.526 331.379C261.797 329.623 257.43 330.94 257.375 333.731C257.321 336.522 262.62 335.083 265.874 332.535"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M289.375 348.96C289.375 348.96 291.856 340.199 299.175 339.423"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M353.021 344.205L382.276 321.786L363.139 295.914L340.312 313.409C342.966 316.816 345.314 319.795 347.274 322.257C351.011 326.961 351.245 333.552 347.851 338.509L346.996 339.583C348.611 340.011 350.995 341.155 353.021 344.205Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M381.139 320.312L351.888 342.731C349.862 339.681 348.607 340.01 346.996 339.595L341.692 346.396C338.529 351.014 338.121 356.588 340.23 361.786L340.885 361.284L370.7 338.768C369.252 336.762 369.677 333.966 371.656 332.48C373.635 330.995 376.439 331.368 377.96 333.319L386.192 327.098L381.139 320.312Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M339.187 315.331C338.147 313.974 338.405 312.032 339.761 310.992L361.378 294.429C362.734 293.39 364.677 293.647 365.717 295.004C366.756 296.361 366.499 298.303 365.142 299.343L343.526 315.906C342.169 316.945 340.227 316.688 339.187 315.331Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M356.686 339.058C356.686 339.058 362.436 328.674 356.219 317.843C352.53 312.355 350.57 310.473 350.57 310.473"
        fill="white"
      />
      <path
        d="M356.686 339.058C356.686 339.058 362.436 328.674 356.219 317.843C352.53 312.355 350.57 310.473 350.57 310.473"
        stroke="#1D2B47"
      />
      <path
        d="M347.479 327.623C347.479 327.623 347.252 324.487 350.933 324.221"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M347.977 330.744C347.977 330.744 348.443 327.627 352.093 328.18"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M347.883 332.81C347.883 332.81 349.239 329.968 352.587 331.559"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M345.87 325.22C345.87 325.22 345.643 322.084 349.323 321.818"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M344.253 322.814C344.253 322.814 344.025 319.678 347.702 319.411"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M343.621 325.926C343.621 325.926 334.499 326.749 336.381 329.717C338.262 332.684 343.162 329.458 341.516 328.509C339.869 327.561 337.204 331.253 338.866 333.519C340.528 335.785 343.852 331.402 344.887 327.404"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M373.523 326.15C373.523 326.15 370.164 317.686 375.483 312.622"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path d="M340.509 301.242L321.328 259.231" stroke="#1D2B47" />
      <path d="M282.125 306.683L287.488 263.151" stroke="#1D2B47" />
      <path d="M359.078 269.752L366.832 277.886" stroke="#1D2B47" />
      <path d="M309.449 304.919L308.328 288.941" stroke="#1D2B47" />
      <path
        d="M188.832 112.506L184.269 113.564L175.786 108.225C174.716 107.552 174.044 106.396 173.988 105.132C173.933 103.869 174.5 102.659 175.508 101.894L187.522 92.7605L198.165 94.8812L199.733 108.339L198.949 109.123C196.67 111.326 193.617 112.549 190.447 112.529L188.832 112.506Z"
        fill="#EEC493"
      />
      <path
        d="M199.714 108.339C196.923 111.036 195.276 111.867 191.125 112.412"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M283.642 199.847L267.64 204.841C265.975 205.363 264.198 204.464 263.63 202.815L263.289 201.835L281.662 194.12L283.642 199.847Z"
        fill="#EEC493"
      />
      <path
        d="M281.662 194.12L263.289 201.846L263.63 202.826C264.198 204.476 265.975 205.374 267.64 204.853L272.235 203.422C272.235 203.422 273.265 208.949 280.106 211.015"
        stroke="#1A1C35"
        strokeLinecap="round"
      />
      <path
        d="M280.693 211.105L273.617 226.115C273.202 226.999 272.15 227.382 271.265 226.97C270.441 226.593 270.033 225.658 270.316 224.798L275.412 209.467L280.693 211.105Z"
        fill="#EEC493"
        stroke="#1A1C35"
        strokeLinecap="round"
      />
      <path
        d="M277.509 212.387L274.714 216.162L273.37 217.973L267.635 225.719C267.06 226.502 265.962 226.677 265.173 226.111C264.438 225.582 264.222 224.584 264.671 223.798L272.664 209.761L277.509 212.387Z"
        fill="#EEC493"
      />
      <path
        d="M274.299 216.719L273.37 217.973L267.635 225.719C267.06 226.502 265.962 226.677 265.173 226.111C264.438 225.582 264.222 224.584 264.671 223.798L272.664 209.761L277.509 212.395"
        stroke="#1A1C35"
        strokeLinecap="round"
      />
      <path
        d="M273.596 211.548L262.299 223.7C261.639 224.408 260.534 224.457 259.814 223.81C259.147 223.202 259.042 222.19 259.571 221.458L269.073 208.397L273.596 211.548Z"
        fill="#EEC493"
      />
      <path
        d="M270.531 214.853L262.299 223.704C261.639 224.412 260.534 224.461 259.814 223.814C259.147 223.206 259.042 222.194 259.571 221.462L269.073 208.401L273.596 211.556"
        stroke="#1A1C35"
        strokeLinecap="round"
      />
      <path
        d="M270.337 209.326L260.188 218.6C259.474 219.251 258.373 219.222 257.695 218.534C257.052 217.88 257.005 216.848 257.585 216.139L265.598 206.339L270.337 209.326Z"
        fill="#EEC493"
      />
      <path
        d="M277.799 217.248L264.812 207.37L270.253 200.345L282.707 193.512L287.243 210.314C285.252 213.667 282.027 216.106 278.258 217.107L277.799 217.248Z"
        fill="#EEC493"
      />
      <path
        d="M287.366 210.306C285.331 213.667 282.07 216.106 278.271 217.107L277.805 217.232"
        stroke="#1A1C35"
        strokeLinecap="round"
      />
      <path
        d="M271.312 198.436L282.72 193.512"
        stroke="#1A1C35"
        strokeLinecap="round"
      />
      <path
        d="M267.734 211.795L260.188 218.6C259.474 219.251 258.373 219.222 257.695 218.534C257.052 217.88 257.005 216.848 257.585 216.139L268.42 202.595"
        stroke="#1A1C35"
        strokeLinecap="round"
      />
      <path
        d="M158.115 82.6707C157.564 82.176 157.518 81.3284 158.013 80.7775C158.508 80.2267 159.355 80.1812 159.906 80.676L196.745 113.765C197.296 114.259 197.342 115.107 196.847 115.658C196.352 116.209 195.504 116.254 194.954 115.759L158.115 82.6707Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M158.477 80.2363L157.528 81.2947C157.296 81.5536 157.317 81.9515 157.575 82.1845L165.858 89.6325L167.65 87.6372L159.367 80.1892C159.243 80.0767 159.079 80.0184 158.912 80.0272C158.745 80.0361 158.588 80.1113 158.477 80.2363Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M186.058 114.658C187.597 115.27 189.355 114.767 190.339 113.435L193.373 109.334C193.917 108.637 193.812 107.633 193.134 107.065C192.491 106.524 191.544 106.554 190.938 107.135L182.898 112.749L186.058 114.658Z"
        fill="#EEC493"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M182.618 112.607C183.856 113.326 185.424 113.115 186.428 112.094L191.179 107.249C191.877 106.588 191.927 105.493 191.293 104.771C190.694 104.095 189.683 103.974 188.941 104.489L179.023 110.177L182.618 112.607Z"
        fill="#EEC493"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M178.996 110.201C180.246 111.019 181.876 110.961 183.065 110.055L189.153 105.406C189.929 104.837 190.112 103.754 189.568 102.96C189.055 102.208 186.895 101.694 186.091 102.125L177.534 105.677C176.879 105.947 176.427 106.557 176.36 107.263C176.293 107.968 176.623 108.653 177.216 109.04L178.996 110.201Z"
        fill="#EEC493"
      />
      <path
        d="M175.758 108.174L179 110.201C180.25 111.019 181.88 110.961 183.069 110.056L189.156 105.407C189.932 104.837 190.116 103.754 189.572 102.96C189.057 102.208 188.059 101.963 187.255 102.392L180.658 106.163"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M175.845 108.139C177.096 108.959 178.728 108.9 179.918 107.994L186.005 103.341C186.779 102.771 186.963 101.692 186.421 100.898C185.907 100.146 183.736 100.059 182.932 100.487L177.871 104.015L175.562 104.368L175.845 108.139Z"
        fill="#EEC493"
      />
      <path
        d="M175.844 108.139C177.095 108.959 178.727 108.901 179.917 107.994L186.004 103.341C186.778 102.771 186.962 101.692 186.42 100.898C185.906 100.146 184.909 99.8999 184.103 100.326L177.506 104.101"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M195.514 106.081C189.693 104.462 187.451 98.817 187.451 98.817L184.479 102.572C183.409 103.933 181.453 104.2 180.058 103.176L179.219 102.541L183.641 94.6422C184.31 93.4431 185.524 92.6468 186.89 92.5098L190.418 92.0511C196.175 91.3022 201.997 92.8343 206.639 96.32L205.393 107.594"
        fill="#EEC493"
      />
      <path
        d="M101.913 124.379L67.7308 183.671C67.0267 184.894 67.0273 186.4 67.7322 187.623C68.4372 188.845 69.7396 189.599 71.1495 189.6H139.518C140.929 189.601 142.233 188.848 142.939 187.625C143.646 186.402 143.647 184.895 142.942 183.671L108.755 124.379C108.05 123.154 106.746 122.4 105.334 122.4C103.922 122.4 102.618 123.154 101.913 124.379Z"
        fill="#C03434"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M101.336 148.533H109.336V168.8H101.336V148.533Z"
        fill="#E9E9E9"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M101.336 171.466H109.336V178.933H101.336V171.466Z"
        fill="#E9E9E9"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  )
}
